import { render, staticRenderFns } from "./seeDetil.vue?vue&type=template&id=2e474530&scoped=true"
import script from "./seeDetil.vue?vue&type=script&lang=js"
export * from "./seeDetil.vue?vue&type=script&lang=js"
import style0 from "./seeDetil.vue?vue&type=style&index=0&id=2e474530&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e474530",
  null
  
)

export default component.exports